import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useGroup } from "../hooks";

type IGroupParams = {
  id: string;
};

export const Group: React.FC = () => {
  const { id } = useParams<IGroupParams>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, loading } = useGroup(+id!);

  if (loading) return <Loading />;

  const group = data?.group?.result;

  return (
    <>
      <Header
        title="Groupe"
        subtitle={group?.name}
        buttons={[
          {
            actionText: "Modifier",
            bgColor: "indigo",
            textColor: "white",
            link: `/group/${id}/update`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="section">
          <div className="element">
            <div className="card">
              <CardHeader title="Informations générales" />
              <div className="w-full mt-3">
                <p className="label">Nom</p>
                <input className="input w-full" value={group?.name} disabled />
              </div>
              <div className="w-full mt-3">
                <p className="label">Siren</p>
                <input className="input w-full" value={group?.siren ?? ""} disabled />
              </div>
              <div className="w-full mt-3">
                <p className="label">Notes</p>
                <textarea className="input w-full" value={group?.notes} disabled rows={3} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
